// components/SkeletonLoader.jsx
const SkeletonLoader = () => {
    return (
      <div className="min-h-screen bg-gray-50">
        {/* Header Skeleton */}
        <div className="border-b bg-white sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-3 py-3 sm:px-6 sm:py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                {/* Logo Skeleton */}
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg animate-pulse bg-gray-200" />
                <div>
                  {/* Store Name Skeleton */}
                  <div className="h-5 w-32 bg-gray-200 rounded animate-pulse" />
                  <div className="h-3 w-24 bg-gray-200 rounded animate-pulse mt-1" />
                </div>
              </div>
              {/* Cart Button Skeleton */}
              <div className="h-8 w-20 bg-gray-200 rounded-lg animate-pulse" />
            </div>
          </div>
  
          {/* Category Pills Skeleton */}
          <div className="max-w-7xl mx-auto px-2 sm:px-6">
            <div className="flex gap-1.5 pb-3 sm:pb-4 overflow-x-auto scrollbar-hide">
              {[1, 2, 3, 4, 5].map((i) => (
                <div 
                  key={i} 
                  className="h-8 w-24 bg-gray-200 rounded-lg animate-pulse"
                />
              ))}
            </div>
          </div>
        </div>
  
        {/* Products Grid Skeleton */}
        <div className="mx-auto px-2 sm:px-6 py-4 sm:py-6 max-w-7xl">
          {/* Section Title Skeleton */}
          <div className="mb-4 sm:mb-6">
            <div className="h-6 w-48 bg-gray-200 rounded animate-pulse" />
          </div>
  
          {/* Product Cards Grid */}
          <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 sm:gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div 
                key={i} 
                className="bg-white rounded-xl overflow-hidden shadow-sm"
              >
                {/* Product Image Skeleton */}
                <div className="aspect-square bg-gray-200 animate-pulse" />
                
                {/* Product Details Skeleton */}
                <div className="p-2.5 sm:p-3 space-y-2">
                  {/* Title */}
                  <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse" />
                  
                  {/* Description */}
                  <div className="space-y-1">
                    <div className="h-3 w-full bg-gray-200 rounded animate-pulse" />
                    <div className="h-3 w-2/3 bg-gray-200 rounded animate-pulse" />
                  </div>
                  
                  {/* Price and Stock */}
                  <div className="flex items-center justify-between pt-1">
                    <div className="h-4 w-16 bg-gray-200 rounded animate-pulse" />
                    <div className="h-4 w-20 bg-gray-200 rounded-full animate-pulse" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  export default SkeletonLoader;